const initialState = {
  contact_link: null
}

/**
 * Function returns the new state based on the
 * given action.
 *
 * @param {object} state
 * @param {object} action
 */
const ui = ( state = initialState, action ) => {
  switch ( action.type ) {
    default:
      return state
  }
}

export default ui
